module.exports = __webpack_public_path__ + "static/media/html_selected.fed6dfa0.svg";